import { ReactNode } from 'react';

import { Text } from '@mantine/core';

import { PermissionString, Roles } from '@interfaces/users.interface';

import useUserPermissionGuard from '@hooks/useUserPermissionGuard';

import PrivateRoute from './PrivateRoute';

interface PermissionSpecificRouteProps {
  permission: PermissionString;
  relatedOnly?: boolean;
  excludeRoles?: Roles[];
  element: ReactNode;
}

export default function PermissionSpecificRoute({
  permission,
  relatedOnly,
  excludeRoles,
  element,
}: PermissionSpecificRouteProps) {
  const hasPermission = useUserPermissionGuard(
    permission,
    relatedOnly,
    excludeRoles,
  );

  return (
    <PrivateRoute
      element={
        hasPermission ? (
          element
        ) : (
          <Text fs="italic">Non puoi accedere a questa schermata</Text>
        )
      }
    />
  );
}
